import $ from "jquery";
import BD_Block from "@bd-core/bd-block";
import Store_Variable from "@bd-components/store-variable";
import BD_Timer from "@bd-components/bd-timer";
import Store_SequenceHistory from "@bd-components/store-sequence-history";
import BD_GAME_LOGIC from "@bd-core/game-logic";
import { compile } from "@bd-utils/handlerbars-helper";
import videojs from "video.js";
import { createQuestion } from "@bd-utils/question";
import CONFIG from "@bd-core/config";
export class Block_Video extends BD_Block {
  constructor() {
    super();

    this.type = "video";
    this.templateID = "video-template";

    this.elms = {
      playBtn: ".js-play",
      pauseBtn: ".js-pause",
      questionCard: ".questionCard",
      questionCardV2: ".v2-questionCard",
      questionCardV3: ".v3-questionCard",
      questionModal: ".question-modal",
      answer: ".js-answer",
      submit: ".js-submit",
      video: "#js-fullscreen-video",
      backWrapper: ".questionCard__back",
      back: ".js-back",
    };

    this._events = this.getEvents();

    /* custom attributes */
    this.video = null;
    this.isSubmitted = false;
  }

  getEvents() {
    const elms = this.elms;
    return [
      {
        event: "click",
        selector: elms.playBtn,
        handler: this.onPlayVideo,
      },
      {
        event: "click",
        selector: elms.pauseBtn,
        handler: this.onPauseVideo,
      },
      {
        event: "click",
        selector: elms.submit,
        handler: this.submit,
      },
      {
        event: "click",
        selector: elms.back,
        handler: this.back,
      },
    ];
  }

  beforeInit() {
    this.render();
    this.setupVideo();
    this.setGameState();
    this.setQuestion();
    this.setTimer();
  }

  render() {
    const htmlTemplate = $("#" + this.templateID).html();
    const videoFromVariable = Store_Variable.getVideoFromVariable(this._data);
    this._data.video = videoFromVariable || this._data.video;

    const html = compile(htmlTemplate, this._data);
    $("#templateWrapper").html(html);

    const siteSetup = CONFIG.siteSetup;
    const disableTransparentQuestionPoup =
      this._data?.disable_transparent_question_popup;

    // this validate the frontend class name on game screen available for v2 and above
    // but on v4 and above there's a function to enable and disable this transparency
    if (siteSetup.includes("stt")) {
      const version = Number(CONFIG.STTVersion);
      $(".gameScreen").toggleClass(
        "v3-questionCard",
        version >= 2 && !(version >= 4 && disableTransparentQuestionPoup),
      );
    } else if (siteSetup === "nuclear-quickscan") {
      $(".gameScreen").addClass("v3-questionCard");
    }
  }

  setupVideo() {
    const _this = this;
    const elms = this.elms;
    const $elVideo = $(elms.video);
    const replayVideo =
      CONFIG.game_options.building_block.video.video_disable_replay;

    if ($elVideo.length < 0) {
      return false;
    }

    const $questionCard = $(elms.questionCard);
    const $questionCardV2 = $(elms.questionCardV2);
    const $questionModal = $(elms.questionModal);
    const isVersion3 = $(".gameScreen").hasClass("v3-questionCard");

    this.video = videojs($elVideo.attr("id"), {
      controls: true,
      autoplay: true,
      preload: "auto",
      loop: this._data.is_looping && this._data.has_question,
    });

    // TODO change to video can play throu
    _this.video.ready(function () {
      //set default style of subtitle
      // @ts-ignore
      const settings = this.textTrackSettings;

      settings.setValues({
        backgroundOpacity: "0",
        edgeStyle: "dropshadow",
      });

      settings.updateDisplay();
    });

    //Start the video
    this.video.on("canplaythrough", () => {
      const startPlayPromise = this.video.play();
      if (startPlayPromise !== undefined) {
        startPlayPromise
          .then(() => {
            // Start whatever you need to do only after playback
            // has begun.
            $questionCard.addClass("videoPlaying");
            $questionModal.addClass("is-load-question");
          })
          .catch(() => {});
      }
    });

    this.video.on("timeupdate", () => {
      const timeStamp = this._data?.video_timestamp;
      const timeToSecond = parseInt(this.timestampToSecond(timeStamp)) + 1;
      const duration = this.video.duration();
      const currrentTime = this.video.currentTime();

      if (isNaN(duration)) return false;

      if (currrentTime < duration - timeToSecond) {
        this.isSubmitted = false;
        return false;
      }

      if (isVersion3) {
        $(elms.playBtn).hide();
        $(".vjs-control-bar").hide();
      }

      if (this.video.isFullscreen()) {
        this.video.exitFullscreen();
      }
      if ($questionCardV2) {
        $questionModal.addClass("is-load-question");
        $(".question-modal").fadeIn(500);
      }

      if (this.isSubmitted) return false;

      $questionCard.addClass("is-opened");
      this.timer.start();
      this.question.showSubmitBtn(this);
    });

    this.video.on("play", () => {
      $questionCard.addClass("videoPlaying");
      if (replayVideo) {
        $(elms.playBtn).hide();
      }

      setTimeout(() => {
        $(".js-video-modal").addClass("is-active");
      }, 2000);
    });

    this.video.on("ended", () => {
      $questionCard.removeClass("videoPlaying");
      // $(".js-play").show();
      $(".js-video-modal").removeClass("is-active");
    });
  }

  setNoQuestion() {
    this.video.on("ended", () => {
      BD_GAME_LOGIC.goToDefaultNextBlock();
    });
  }

  setGameState() {
    const showBackBtn = () => {
      if (Store_SequenceHistory.data) {
        $(this.elms.backWrapper).addClass("is-active");
      }
    };

    showBackBtn();

    if (!this._data.has_question) {
      this.setNoQuestion();
    }
  }

  setQuestion() {
    this.question = createQuestion(this._data.question);
    this._events = [...this._events, ...this.question.getEvents()];
  }

  setTimer() {
    this.timer = new BD_Timer(this._data, this.question);
  }

  timestampToSecond(time) {
    if (time === "") return 0;

    const split = time.replace(/\s/g, "").split(":");
    const minute = split[0] * 60;
    const second = split[1];

    return minute + second;
  }

  /* ========= ELEMENT FUNCTION HANDLER ===============*/
  onPlayVideo(e) {
    if (e) e.preventDefault();
    const _this = this;
    const $questionCard = $(_this.elms.questionCard);
    const $submitButton = $(_this.elms.submit);

    const isVersion3 = $(".gameScreen").hasClass("v3-questionCard");

    if (isVersion3) {
      $questionCard.removeClass("is-opened");
      $submitButton.parent().removeClass("is-active");
    }

    _this.video
      .play()
      .then(() => {
        $questionCard.addClass("videoPlaying");
        if ($questionCard.width() < 1024 || $questionCard.hasClass("is-slider"))
          $questionCard.removeClass("is-opened");
        $(".question-modal").fadeOut(500);
      })
      .catch(() => {
        // Autoplay was blocked. Do something
      });
  }

  onPauseVideo(e) {
    if (e) e.preventDefault();
    const _this = this;
    const $questionCard = $(_this.elms.questionCard);

    if (!_this.video.paused()) {
      _this.video.pause();
      $questionCard.removeClass("videoPlaying");
    }
  }

  back() {
    const seqHistory = Store_SequenceHistory.data;
    const currentBlockID = parseInt(BD_GAME_LOGIC.getCurrentBlockID());
    const history = seqHistory[currentBlockID];
    if (!history) return;

    BD_GAME_LOGIC.goBack(history.prev);
  }

  submit(e, $el) {
    this.question.submitAnswer($el, this);
    if (Number(CONFIG.STTVersion ?? 2) !== 4) {
      $(this.elms.questionCard).removeClass("is-opened");
    }

    this.isSubmitted = true;
  }

  beforeDestroy() {
    this.timer.stop();
    if (this.video) {
      this.video.dispose();
    }
  }
}
